import { BrowserModule }    from '@angular/platform-browser';  
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SigninComponent } from './comm/signin/signin.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from './layout/layout.module';
import { CommModule } from './comm/comm.module';
import { HttpcontrollerService } from './service/httpcontroller.service';
import {
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    AppComponent,SigninComponent, 
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    LayoutModule,
    CommModule,
    NgbModule,
  ],
  exports: [
    SigninComponent
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpcontrollerService,
    multi: true,
  }],
  bootstrap: [AppComponent]
})

export class AppModule { }
